import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import Loader from "components/Shared/Loader/Loader";
import SimpleBackdrop from "utils/general";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { OverlayPanel } from "primereact/overlaypanel";
import _ from "lodash";
import { SelectButton } from "primereact/selectbutton";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as ExcelJS from "exceljs";
import FileSaver from "file-saver";
import moment from "moment";

const filterOptions = ["Today", "7 Days", "30 Days"];

const PriceDifferenceReport = (props) => {
  const initialFilterState = {
    FilterDate: "",
    FromDate: [new Date(), new Date()],
    Item: [],
    Vendor: [],
  };
  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const [priceDifferenceReportList, setPriceDifferenceReportList] = useState(
    [],
  );
  const [userId, setUserId] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [
    filteredPriceDifferenceReportList,
    setFilteredPriceDifferenceReportList,
  ] = useState([]);

  const [itemList, setItemList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [filterData, setFilterData] = useState(initialFilterState);
  const [showCalendar, setShowCalendar] = useState(false);
  const [tempFromDate, setTempFromDate] = useState(initialFilterState.FromDate);

  const [userPageAccess, setUserPageAccess] = useState([]);

  const op = useRef(null);

  useEffect(() => {
    if (op.current) {
      const patcher = (methodName) => {
        const originalMethod = op.current[methodName];
        if (originalMethod) {
          op.current[methodName] = (event) => {
            // Check if the click target is no longer in the DOM.
            // This happens with the calendar month/year navigation arrows,
            // which are removed on click, causing a false "outside" click detection.
            if (event.target && !document.body.contains(event.target)) {
              return false; // This was an inside click on a removed element.
            }
            // Proceed with the original logic.
            return originalMethod.call(op.current, event);
          };
        }
      };
      patcher("isOutsideClicked");
      patcher("hasOutsideClicked");
    }
  }, []);

  useEffect(() => {
    let token = localStorage.getItem("Token");
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);
    getItemList(data);
    getVendorList(data);
  }, []);

  useEffect(() => {
    if (!filterData.FilterDate) return;

    const today = moment();
    let range = null;

    switch (filterData.FilterDate) {
      case "Today":
        range = [today.startOf("day").toDate(), today.endOf("day").toDate()];
        break;
      case "7 Days":
        range = [
          moment()
            .subtract(6, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      case "30 Days":
        range = [
          moment()
            .subtract(29, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      default:
        range = null;
    }

    if (range) {
      setFilterData((prevState) => ({
        ...prevState,
        FromDate: range,
      }));
    }
  }, [filterData.FilterDate]);

  const getItemList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetItemMasterList, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter(
            (x) => x.UserId !== "Admin",
          ).map((item) => ({
            label: item.label || item.Item,
            value: item.value || item._id,
          }));
          setItemList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const getVendorList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Vendor",
    };
    api
      .post(APIConstant.path.GetNotVerifiedNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.Name,
              value: data._id,
            }),
          );

          setVendorList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetPriceDifferenceReport = async (UserId, filter) => {
    let tempFilter = filter || filterData;
    Loader.show();
    if (validate()) {
      try {
        let params = {
          UserId: UserId,
          Filters: tempFilter,
        };
        await api
          .post(APIConstant.path.GetPriceDifferenceReport, params)
          .then(async (res) => {
            if (res.Success === 1) {
              Loader.hide();
              setPriceDifferenceReportList(res.Data);
              setFilteredPriceDifferenceReportList(res.Data);
              op.current.hide();
            } else {
              Loader.hide();
              setPriceDifferenceReportList([]);
              setFilteredPriceDifferenceReportList([]);
              op.current.hide();
            }
          })
          .catch((err) => {
            console.log(err);
            Loader.hide();
          });
      } catch (err) {
        console.error(err);
        Loader.hide();
      }
    } else {
      Loader.hide();
    }
  };

  const validate = () => {
    let isValid = true;

    return isValid;
  };

  const handleReset = (e) => {
    op.current.hide();
    GetPriceDifferenceReport(userId, initialFilterState);
  };

  const handleGlobalFilter = (e) => {
    setGlobalFilter(e.target.value);
    if (priceDifferenceReportList.length) {
      let filteredPriceDifferenceReportList = priceDifferenceReportList;
      if (e.target.value) {
        filteredPriceDifferenceReportList = filteredPriceDifferenceReportList.filter(
          (x) => {
            return (
              x.ItemName.toLowerCase().indexOf(e.target.value.toLowerCase()) !==
              -1
            );
          },
        );
        setFilteredPriceDifferenceReportList(filteredPriceDifferenceReportList);
      }

      setFilteredPriceDifferenceReportList(filteredPriceDifferenceReportList);
    }
  };

  const getDateRange = () => {
    const { FilterDate, FromDate } = filterData;
    let startDate, endDate;

    if (FilterDate) {
      const today = moment().startOf("day");

      switch (FilterDate) {
        case "Today":
          startDate = today.clone();
          endDate = today.clone().endOf("day");
          break;
        case "7 Days":
          startDate = today
            .clone()
            .subtract(6, "days")
            .startOf("day");
          endDate = today.clone().endOf("day");
          break;
        case "30 Days":
          startDate = today
            .clone()
            .subtract(29, "days")
            .startOf("day");
          endDate = today.clone().endOf("day");
          break;
        default:
          startDate = today.clone();
          endDate = today.clone().endOf("day");
      }
    } else {
      startDate = FromDate[0]
        ? moment(FromDate[0]).startOf("day")
        : moment().startOf("day");
      endDate = FromDate[1]
        ? moment(FromDate[1]).endOf("day")
        : moment().endOf("day");
    }

    const totalDays = endDate.diff(startDate, "days") + 1;
    const dateRangeText = `From ${startDate.format(
      "DD-MMM-YYYY",
    )} to ${endDate.format("DD-MMM-YYYY")}`;

    return { startDate, endDate, totalDays, dateRangeText };
  };

  const exportToExcel = async () => {
    if (filteredPriceDifferenceReportList.length) {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Price Difference Report");

        const columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Item Name", field: "ItemName" },
          { header: "Total Purchases", field: "TotalPurchases" },
          { header: "Min Price", field: "MinPrice" },
          { header: "Max Price", field: "MaxPrice" },
          { header: "Average Price", field: "AveragePrice" },
          { header: "Median Price", field: "MedianPrice" },
          { header: "Price Difference", field: "PriceDifference" },
          { header: "Cheapest Vendor", field: "CheapestVendor" },
          { header: "Most Expensive Vendor", field: "MostExpensiveVendor" },
        ];

        // Set column widths and keys
        worksheet.columns = columns.map((col) => ({
          key: col.field,
          width: col.header.length < 20 ? 20 : col.header.length + 5,
        }));

        const { dateRangeText } = getDateRange();
        const getLabels = (selectedValues, masterList) => {
          if (!selectedValues || selectedValues.length === 0) return "All";
          return selectedValues
            .map((val) => {
              const found = masterList.find((item) => item.value === val);
              return found ? found.label || found.Name : val;
            })
            .join(", ");
        };

        const filterStrings = [
          `Date: ${dateRangeText}`,
          `Items: ${getLabels(filterData.Item, itemList)}`,
          `Vendors: ${getLabels(filterData.Vendor, vendorList)}`,
        ];

        // Metadata rows
        worksheet.addRow(["Report Name", "Price Difference Report"]).font = {
          bold: true,
          size: 14,
        };
        worksheet.addRow(["Filter", filterStrings.join(" | ")]).font = {
          bold: true,
        };
        worksheet.addRow([
          "Generated On",
          moment().format("DD-MMM-YYYY HH:mm"),
        ]).font = { bold: true };
        worksheet.addRow([]); // Blank row row 4

        // Add Header Row (Row 5)
        worksheet.addRow(columns.map((col) => col.header)).font = {
          bold: true,
        };

        // Totals
        let totalPurchases = 0;
        let totalMinPrice = 0;
        let totalMaxPrice = 0;
        let totalAveragePrice = 0;
        let totalMedianPrice = 0;
        let totalPriceDifference = 0;

        filteredPriceDifferenceReportList.forEach((item, index) => {
          const row = {};
          columns.forEach((col) => {
            row[col.field] =
              col.field === "Index" ? index + 1 : item[col.field] || "";
          });

          totalPurchases += parseFloat(item.TotalPurchases) || 0;
          totalMinPrice += parseFloat(item.MinPrice) || 0;
          totalMaxPrice += parseFloat(item.MaxPrice) || 0;
          totalAveragePrice += parseFloat(item.AveragePrice) || 0;
          totalMedianPrice += parseFloat(item.MedianPrice) || 0;
          totalPriceDifference += parseFloat(item.PriceDifference) || 0;

          worksheet.addRow(row);
        });

        worksheet.addRow([]);

        const totalRow = {};
        columns.forEach((col) => {
          switch (col.field) {
            case "TotalPurchases":
              totalRow[col.field] = totalPurchases;
              break;
            case "MinPrice":
              totalRow[col.field] = totalMinPrice.toFixed(2);
              break;
            case "MaxPrice":
              totalRow[col.field] = totalMaxPrice.toFixed(2);
              break;
            case "AveragePrice":
              totalRow[col.field] = totalAveragePrice.toFixed(2);
              break;
            case "MedianPrice":
              totalRow[col.field] = totalMedianPrice.toFixed(2);
              break;
            case "PriceDifference":
              totalRow[col.field] = totalPriceDifference.toFixed(2);
              break;
            default:
              totalRow[col.field] = "";
          }
        });

        worksheet.addRow(totalRow).font = { bold: true };

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, `Price_Difference_Report.xlsx`);
      } catch (error) {
        console.error("Error exporting Price Difference Report:", error);
      }
    }
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      {loading === true ? (
        <div className="loading">
          <SimpleBackdrop />
        </div>
      ) : null}
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-upload"></i>
          <h2>Price Difference Report</h2>
        </div>

        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              className="searchbar"
              type="search"
              onChange={(e) => handleGlobalFilter(e)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!globalFilter ? <i className="icon-search"></i> : null}
          </div>

          <div
            className="e-add-btn"
            onClick={(e) => {
              exportToExcel();
            }}
          >
            <i className="pi pi-file-excel"></i>
          </div>

          <div className="p-position-relative">
            <Button
              onClick={(e) => {
                op.current.toggle(e);
              }}
              icon="icon-filter"
              rounded
              className="wb-search-btn p-ml-2"
            />

            {/* <button onClick={generatePDF}>Export PDF</button> */}
            <div className="header-bar">
              <div className="right-nav-buttons p-d-flex">
                <div>
                  <div className="noti-dropdown-outer">
                    <OverlayPanel
                      ref={op}
                      style={{ width: 500 }}
                      className="wayment-slip-filter"
                    >
                      <div>
                        <div role="menu">
                          <div className="p-grid p-p-2 trip-filter-box">
                            <div className="p-col-12  p-md-12 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">
                                    Select Date
                                  </label>
                                  <div className="p-d-flex p-ai-center">
                                    <SelectButton
                                      className="wb-filter-dt"
                                      value={filterData.FilterDate}
                                      onChange={(e) => {
                                        setFilterData((prevState) => ({
                                          ...prevState,
                                          FilterDate: e.value,
                                          FromDate: null,
                                        }));
                                      }}
                                      options={filterOptions}
                                    />
                                    <div className="custom-date-picker-wrapper p-mt-2 p-position-relative">
                                      <div
                                        className="p-inputgroup"
                                        onClick={() => {
                                          if (!showCalendar) {
                                            setTempFromDate(
                                              filterData.FromDate || [
                                                new Date(),
                                                new Date(),
                                              ],
                                            );
                                          }
                                          setShowCalendar(!showCalendar);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <InputText
                                          readOnly
                                          style={{
                                            cursor: "pointer",
                                            height: "40px",
                                            backgroundColor: "#fff",
                                          }}
                                          placeholder="Start Date - End Date"
                                          value={
                                            Array.isArray(
                                              filterData.FromDate,
                                            ) && filterData.FromDate[0]
                                              ? `${moment(
                                                  filterData.FromDate[0],
                                                ).format("DD/MM/YYYY")} - ${
                                                  filterData.FromDate[1]
                                                    ? moment(
                                                        filterData.FromDate[1],
                                                      ).format("DD/MM/YYYY")
                                                    : ""
                                                }`
                                              : filterData.FromDate &&
                                                !Array.isArray(
                                                  filterData.FromDate,
                                                )
                                              ? moment(
                                                  filterData.FromDate,
                                                ).format("DD/MM/YYYY")
                                              : ""
                                          }
                                        />
                                        <Button
                                          type="button"
                                          icon="pi pi-calendar"
                                          style={{ height: "40px" }}
                                        />
                                      </div>
                                      {showCalendar && (
                                        <div
                                          className="p-p-2 p-mt-1"
                                          style={{
                                            position: "absolute",
                                            zIndex: 1000,
                                            top: "100%",
                                            right: 0,
                                            border: "1px solid #ced4da",
                                            borderRadius: "4px",
                                            backgroundColor: "#ffffff",
                                            width: "325px",
                                            boxShadow:
                                              "0 4px 6px rgba(0, 0, 0, 0.1)",
                                          }}
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <Calendar
                                            inline
                                            selectionMode="range"
                                            value={tempFromDate}
                                            onChange={(e) =>
                                              setTempFromDate(e.value)
                                            }
                                          />
                                          <div
                                            className="p-d-flex p-jc-end p-mt-2 p-pt-2"
                                            style={{
                                              borderTop: "1px solid #ced4da",
                                            }}
                                          >
                                            <Button
                                              type="button"
                                              label="Cancel"
                                              className="p-button-text p-button-secondary p-mr-2"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setTempFromDate(
                                                  filterData.FromDate,
                                                );
                                                setTimeout(
                                                  () => setShowCalendar(false),
                                                  10,
                                                );
                                              }}
                                            />
                                            <Button
                                              type="button"
                                              label="OK"
                                              className="primary-btn"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setFilterData((prevState) => ({
                                                  ...prevState,
                                                  FilterDate: null,
                                                  FromDate: tempFromDate,
                                                }));
                                                setTimeout(
                                                  () => setShowCalendar(false),
                                                  10,
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-col-12  p-md-6 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">Items</label>
                                  <MultiSelect
                                    className="p-w-100 p-mt-1"
                                    value={filterData.Item}
                                    options={itemList}
                                    optionLabel="label"
                                    display="chip"
                                    fixedPlaceholder={true}
                                    placeholder="Select Items"
                                    onChange={(e) => {
                                      setFilterData((prevState) => ({
                                        ...prevState,
                                        Item: e?.value,
                                      }));
                                      e.stopPropagation();
                                    }}
                                    filter
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="p-col-12  p-md-6 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">Vendor</label>
                                  <MultiSelect
                                    className="p-w-100 p-mt-1"
                                    value={filterData.Vendor}
                                    options={vendorList}
                                    optionLabel="label"
                                    display="chip"
                                    fixedPlaceholder={true}
                                    placeholder="Select Vendors"
                                    onChange={(e) => {
                                      setFilterData((prevState) => ({
                                        ...prevState,
                                        Vendor: e?.value,
                                      }));
                                      e.stopPropagation();
                                    }}
                                    filter
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="noti-footer">
                          <div className="p-d-flex p-ml-2 p-mb-1">
                            <Button
                              className="primary-btn1"
                              onClick={(e) => {
                                handleReset(e);
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              className="primary-btn p-ml-2"
                              onClick={() => GetPriceDifferenceReport(userId)}
                            >
                              Filter
                            </Button>
                          </div>
                        </div>
                      </div>
                    </OverlayPanel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="export-custom-large-wb-table">
        <DataTable
          className="main-table table-td"
          value={filteredPriceDifferenceReportList}
          responsiveLayout="scroll"
          totalRecords={filteredPriceDifferenceReportList.length}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "6%" }}
          ></Column>

          <Column field="Date" header="Date" style={{ width: "10%" }}></Column>
          <Column
            field="ItemName"
            header="Item Name"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="TotalPurchases"
            header="Total Purchases"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MinPrice"
            header="Min Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MaxPrice"
            header="Max Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="AveragePrice"
            header="Average Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MedianPrice"
            header="Median Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="PriceDifference"
            header="Price Difference"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="CheapestVendor"
            header="Cheapest Vendor"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MostExpensiveVendor"
            header="Most Expensive Vendor"
            style={{ width: "12%" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default PriceDifferenceReport;
